module.exports = __webpack_public_path__ + "img/youpaq-script-white.9eec48d6.svg";